import React from 'react';

const Loading = () => (
  <div className="bg-[#68C7CC] flex justify-center items-center h-screen">
    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-white"></div>
  </div>
);

export default Loading;